import Urls from '../Urls'
import { axiosInstance } from "./AxiosInstance"
class HeaderReq {
    Config = () => {
        return axiosInstance({
            method: 'get',
            url: Urls.Config(),
        })
    }
    AppConfig = () => {
        return axiosInstance({
            method: 'GET',
            url: Urls.AppConfig()
        })
    }

}
export default new HeaderReq
